import { Banner } from '@forgeglobal/design-framework';
import { NotificationContext } from '@tcs/client-portal-common/providers/NotificationProvider';
import { filter, uniqBy } from 'lodash';
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

const NotificationZone = () => {
  const { notifications: data } = useContext(NotificationContext);
  const { accountNumber } = useParams();

  const notifications = useMemo(() => {
    // sort notifications by type and highest status of each type
    data.sort(function (a, b) {
      // Sort by type first
      const typeComparison = a.type.localeCompare(b.type);
      // If the types are the same, sort by status
      if (typeComparison === 0) {
        return a.status.localeCompare(b.status);
      }
      return typeComparison;
    });

    if (accountNumber) {
      return uniqBy(
        filter(data, ({ id }) => id === accountNumber),
        'type'
      );
    }

    return uniqBy(data, 'type');
  }, [data, accountNumber]);

  if (!notifications.length) return null;

  return notifications.map(({ status, action, text, type }) => (
    <Banner
      data-test-id="notification-banner"
      severity={status}
      action={action}
      key={type}>
      {text}
    </Banner>
  ));
};

export default NotificationZone;
